module.exports = __webpack_public_path__ + "static/first-aaf7e919e7d44188990d7db429a2ce6a.png";